import defaultJson from "../config/simulationDefault.json";
import { convertRataFromPercToEuro } from "../helpers/Pipes";

export const Simulation = () => {};

Simulation.allTables = [];
Simulation.snapshot = {
    EsitoOTP: "",
};

const roundValue = (value, roundBy = 5) => {
    const val = value.toString().replace(",", ".");
    return Math.ceil(parseFloat(val) / roundBy) * roundBy;
};
const rroundValue = (value, roundBy = 5) => {
    const val = value.toString().replace(",", ".");
    return Math.round(parseFloat(val) / roundBy) * roundBy;
};

Simulation.update = (importo, rataPerc) => {
    // 1. get eligible tables based on importo
    const eligibleTables = Simulation.allTables.filter((t) => t.ImpRich == importo);

    if (!eligibleTables.length) return;

    // 2. get rata range display min and max
    const rataRangeMin = roundValue(eligibleTables[eligibleTables.length - 1].maxRata) >= 50 ? roundValue(eligibleTables[eligibleTables.length - 1].maxRata) : 50;
    const rataRangeMax = roundValue(eligibleTables[0].maxRata);

    // 3. convert rata from % to €
    let newRataStep = 1;
    try {
        newRataStep = 100 / ((rataRangeMax - rataRangeMin) / defaultJson.rataStep);
        if (!isFinite(newRataStep)) newRataStep = 1;
    } catch (error) {}

    const newRataPerc = rroundValue(rataPerc, newRataStep);
    const _newRataEuro = ((rataRangeMax - rataRangeMin) * newRataPerc) / 100;
    const rata = rroundValue(rataRangeMin + _newRataEuro, defaultJson.rataStep);

    // 4. get min and max gravitypoints for all values based on rata
    const rrata = rata >= rataRangeMin && rata <= rataRangeMax ? rata : rata < rataRangeMin ? rataRangeMin : rataRangeMax;
    const minTable = eligibleTables.filter((t) => parseFloat(t.minRata.replace(",", ".")) <= rrata)[0];
    const maxTable = eligibleTables.filter((t) => parseFloat(t.maxRata.replace(",", ".")) <= rrata)[0];

    Simulation.snapshot = {
        ...Simulation.snapshot,
        rataPerc: newRataPerc,
        rataStep: newRataStep,
        rataValue: rata,
        rataRangeMin,
        rataRangeMax,
        minTAEG: minTable.minTAEG,
        maxTAEG: maxTable.maxTAEG,
        minTAN: minTable.minTAN,
        maxTAN: maxTable.maxTAN,
        minImporto: minTable.minDovuto,
        maxImporto: maxTable.maxDovuto,
        minRata: minTable.minRata,
        maxRata: maxTable.maxRata,
        minDurata: minTable.NumRate,
        maxDurata: maxTable.NumRate,
        minIstruttoria: minTable.comm,
        maxIstruttoria: maxTable.maxCommissioni,
        minOneri: minTable.impBollo,
        maxOneri: maxTable.maxImpBollo,
        oneriTrasparenza: maxTable.impTrasparenza,
    };
};

Simulation.set = (key, value) => {
    Simulation.snapshot[key] = value;
};

Simulation.merge = (object) => {
    Simulation.snapshot = { ...Simulation.snapshot, ...object };
};

Simulation.merge = (object) => {
  Simulation.snapshot = {...Simulation.snapshot, ...object};
};

Simulation.get = (key) => {
    if (!key) return Simulation.snapshot;
    return Simulation.snapshot[key] || defaultJson[key];
};

Simulation.getRataConverted = (rataValue, min = 0, max = 0) => {
    return convertRataFromPercToEuro(rataValue, min || Simulation.get("rataRangeMin"), max || Simulation.get("rataRangeMax"));
};
